import adaptiveSpeaker from "../../assets/icons/adaptive_speaker.svg";
import video from "../../assets/icons/video.svg";
import placeAddress from "../../assets/icons/place_address.svg";
import simCard from "../../assets/icons/sim_card.svg";
import travelKeys from "../../assets/icons/travel_keys.svg";
import announcement from "../../assets/icons/announcement.svg";
import fast from "../../assets/icons/fast.svg";
import onDemand from "../../assets/icons/on_demand.svg";

export const SUBSCRIPTIONS_ICONS_MAP = {
  "Vehicle Tracking": onDemand,
  "Vehicle Tracking EZ": onDemand,
  "Powered Asset Tracker": adaptiveSpeaker,
  "Non-Powered Asset Tracker": adaptiveSpeaker,
  "AI Dash Cam": video,
  EVC: placeAddress,
  "SD Card": simCard,
  "Driver ID": travelKeys,
  "Panic Button": announcement,
  PTO: fast,
};

export const ASSET_TYPE = {
  VEHICLE: "Vehicle",
  POWERED_ASSET: "Powered Asset Tracker",
  NON_POWERED_ASSET: "Non-Powered Asset Tracker",
};

export const BULK_TEXT_AREA = {
  placeholder: "Provide specific details about key location (e.g., glove box), alarm codes, or vehicle-specific instructions to help the installer.",
  maxLength: 255,
};

export const BANNER_AUTO_DISMISS_MS = 4500;

export const MESSAGES = {
  SUCCESS_TYPE: "success",
  SUCCESS_HEADER: "Details updated",
  SUCCESS_MESSAGE: "The information has been successfully saved.",
  ERROR_TYPE: "error",
  ERROR_HEADER: "Update failed",
  ERROR_MESSAGE: "The information could not be saved. Please try again.",
  COMMON_ERROR_HEADER: "Fetch error",
  COMMON_ERROR_MESSAGE: "Unable to fetch data due to an unexpected error. Please try again!",
  LOADING_WAIT_MESSAGE: "Hang on while we set up things",
  LOADING_WAIT_MESSAGE_SLOTS: "Reviewing the vendor availability",
};

export const TOOLTIP_MESSAGES = {
  WHEELCHAIR: "Wheelchair lift",
  EMERGENCY: "Emergency vehicle",
  KILLSWITCH: "Master shut-off",
  COMPETITOR_DEVICE: "Competitor device",
  COMPETITOR_DEVICE_REMOVED: "Competitor device removed",
};

export const COLORS = {
  COMPETITOR_COMPLETE: "#A4E6BD",
  COMPETITOR_INCOMPLETE: "#FFCAAA",
  //  other colors
};

/** All possible bulk-action keys used across the feature. */
export const ACTION_KEYS = {
  SET_VMI: "SET_INSTALL_TYPE_VMI",
  SET_CMI: "SET_INSTALL_TYPE_CMI",
  ADD_EDIT_NOTE: "ADD_NOTES",
  CLEAR_NOTE: "CLEAR_NOTES",
  ADD_FLAG: "ADD_COMPETITOR_DEVICE_REMOVAL_FLAG",
  CLEAR_FLAG: "CLEAR_COMPETITOR_DEVICE_REMOVAL_FLAG",
  BULK_CHANGE_PRIORITY: "BULK_CHANGE_PRIORITY",
  BULK_CHANGE_ADDRESS: "BULK_CHANGE_ADDRESS",
  BULK_DELETE: "BULK_DELETE",
};

export const BULK_ACTION_KEYS = {
  BULK_CHANGE_ADDRESS: "BULK_CHANGE_ADDRESS",
  BULK_CHANGE_PRIORITY: "BULK_CHANGE_PRIORITY",
  BULK_DELETE: "BULK_DELETE",
  GET_SUPPORTED_ACTIONS: "GET_SUPPORTED_ACTIONS",
  SET_INSTALL_TYPE_VMI: "SET_INSTALL_TYPE_VMI",
  SET_INSTALL_TYPE_CMI: "SET_INSTALL_TYPE_CMI",
  ADD_COMPETITOR_DEVICE_REMOVAL_FLAG: "ADD_COMPETITOR_DEVICE_REMOVAL_FLAG",
  CLEAR_COMPETITOR_DEVICE_REMOVAL_FLAG: "CLEAR_COMPETITOR_DEVICE_REMOVAL_FLAG",
  ADD_NOTES: "ADD_NOTES",
  CLEAR_NOTES: "CLEAR_NOTES",
};

/**
 * Maps each action key to its backend actionType and the install-type filter
 * (installType[]) that should be sent when fetching vehicles for that action.
 */
export const ACTION_CONFIG = {
  [ACTION_KEYS.SET_VMI]: {
    actionType: "BULK_SET_INSTALL_TYPE_VMI",
    filterInstallTypes: ["CMI", "CMIC"],
  },
  [ACTION_KEYS.SET_CMI]: {
    actionType: "BULK_SET_INSTALL_TYPE_CMI",
    filterInstallTypes: ["VMI", "VMIC"],
  },
  [ACTION_KEYS.ADD_EDIT_NOTE]: {
    actionType: "BULK_ADD_EDIT_NOTES",
    filterInstallTypes: ["VMI", "VMIC"],
  },
  [ACTION_KEYS.CLEAR_NOTE]: {
    actionType: "BULK_CLEAR_NOTES",
    filterInstallTypes: ["VMI", "VMIC"],
  },
  [ACTION_KEYS.ADD_FLAG]: {
    actionType: "BULK_ADD_COMPETITOR_DEVICE_REMOVAL",
    filterInstallTypes: ["VMI", "VMIC"],
  },
  [ACTION_KEYS.CLEAR_FLAG]: {
    actionType: "BULK_CLEAR_COMPETITOR_DEVICE_REMOVAL",
    filterInstallTypes: ["VMI", "VMIC"],
  },
  [ACTION_KEYS.BULK_CHANGE_ADDRESS]: {
    actionType: "BULK_CHANGE_ADDRESS",
  },
};

export const VEHICLE_EDIT_ACTIONS = {
  VEHICLE_EDIT: "SINGLE_EDIT_VEHICLE",
};

export const VEHICLE_STATUSES = {
  DEFAULT: "Partially Completed",
};
